module.exports = __webpack_public_path__ + "img/Logo_dummy.a40b6cc4.png";